<p class="ion-no-margin ion-margin-bottom">{{ 'quickcoach.import.description' | translate }}</p>

<ng-container *ngIf="loginState.userData">

  <ion-item  lines="none">
    <ion-avatar slot="start" *ngIf="loginState.userData.fields.profile.image_url">
      <img [src]="loginState.userData.fields.profile.image_url" />
    </ion-avatar>
    <ion-label>
      <div>
        {{ loginState.userData.fields.profile.firstName }} {{ loginState.userData.fields.profile.lastName }}
      </div>
      <small *ngIf="loginState.userData.fields.emails[0]">
        {{ loginState.userData.fields.emails[0].address }}
      </small>
    </ion-label>
  </ion-item>

  <ng-container *ngIf="!importedCustomersPayload">
    <p>
      {{ 'quickcoack.total.clients.message' | translate: {
      total: loginState.userData.fields.userIds.length
      }
      }}
    </p>

    <ion-row class="ion-justify-content-end ion-margin-bottom">
      <ion-button color="secondary" fill="outline" (click)="loadCustomers()">
        {{ 'quickcoach.start.import' | translate }}
      </ion-button>
    </ion-row>
  </ng-container>
</ng-container>

<!-- Customers list step  -->
<ng-container *ngIf="importedCustomersPayload">
  <h6>{{ 'quickcoach.customers.list' | translate }} ({{ importedCustomersPayload.length }})</h6>
  <me-bulk-customer-create class="ion-margin-top"
    [payload]="importedCustomersPayload"
    [bulkCreateButtonText]="'quickcoach.import.customers' | translate"
    (onCustomersCreated)="onCustomersImported()"
  >
  </me-bulk-customer-create>
</ng-container>

<!-- Email Step -->
<ng-container *ngIf="loginState.step === 'email'">

  <ion-card class="ion-no-margin ion-padding">
    <form [formGroup]="emailForm" (ngSubmit)="onEmailSubmit()">
      <ion-input
        fill="outline"
        [label]="'email' | translate"
        labelPlacement="floating"
        [errorText]="'email.format.invalid' | translate"
        formControlName="email"
        [placeholder]="'email' | translate"
        type="email"
        autocomplete="email"
        [disabled]="isLoading">
      </ion-input>
    </form>

    <ion-button
      color="secondary"
      fill="outline"
      (click)="onEmailSubmit()"
      class="ion-margin-top"
      [disabled]="emailForm.invalid || isLoading"
      expand="block">
      <ion-spinner *ngIf="isLoading" class="ion-margin-end"></ion-spinner>
      {{ isLoading ? ('quickcoach.sending.code' | translate) : ('quickcoach.login' | translate) }}
    </ion-button>
  </ion-card>
</ng-container>

<!-- Code Step -->
<ng-container *ngIf="loginState.step === 'code'">
  <ion-card class="ion-no-margin ion-padding">
    <form [formGroup]="codeForm" (ngSubmit)="onCodeSubmit()">
      <ion-input
        fill="outline"
        [label]="'quickcoach.verification.code' | translate"
        labelPlacement="floating"
        [errorText]="'is.required' | translate: {fieldName: ('quickcoach.verification.code' | translate)}"
        formControlName="code"
        [placeholder]="'quickcoach.verification.code' | translate"
        [helperText]="'quickcoach.login.code.step' | translate: { email: loginState.email }"
        type="text"
        maxlength="6"
        [disabled]="isLoading">
      </ion-input>

      <input type="submit" hidden>
    </form>

    <div class="ion-margin-top">
      <ion-button
        color="secondary"
        fill="outline"
        (click)="onCodeSubmit()"
        [disabled]="codeForm.invalid || isLoading"
        expand="block">
        <ion-spinner *ngIf="isLoading" name="crescent" class="ion-margin-end"></ion-spinner>
        {{ isLoading ? ('quickcoach.verifying.code' | translate) : ('quickcoach.login' | translate) }}
      </ion-button>

      <ion-button
        class="ion-margin-top"
        fill="outline"
        (click)="onBackToEmail()"
        [disabled]="isLoading"
        expand="block">
        {{ 'action.back' | translate }}
      </ion-button>
    </div>
  </ion-card>
</ng-container>
